import type { Certification } from '@applicator/shared'

export function formatCertificationDates(cert: Certification): string {
  const start = cert.startDate?.trim() ?? ''
  const end = cert.endDate?.trim() ?? ''
  if (start && end) return `${start} - ${end}`
  return start || end
}

export function isCertificationDatesInPreview(cert: Certification): boolean {
  if (!(cert.datesIncluded ?? true)) return false
  return Boolean(formatCertificationDates(cert))
}

export function isCertificationNameInPreview(cert: Certification): boolean {
  return (cert.nameIncluded ?? true) && Boolean(cert.name?.trim())
}

export function isCertificationIssuerInPreview(cert: Certification): boolean {
  return (cert.issuerIncluded ?? true) && Boolean(cert.issuer?.trim())
}

export function isCertificationCredentialLinkInPreview(cert: Certification): boolean {
  return (
    (cert.credentialUrlIncluded ?? true) &&
    Boolean(cert.credentialUrl?.trim()) &&
    isCertificationNameInPreview(cert)
  )
}

/** Shown in preview when master checkbox is on and at least one sub-field is on. */
export function isCertificationInPreview(cert: Certification): boolean {
  if (!cert.included) return false
  return (
    isCertificationNameInPreview(cert) ||
    isCertificationIssuerInPreview(cert) ||
    isCertificationDatesInPreview(cert)
  )
}
